module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/media.07b6a5ea.svg";